import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=1862a979&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1862a979",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1862a979')) {
      api.createRecord('1862a979', component.options)
    } else {
      api.reload('1862a979', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=1862a979&scoped=true&", function () {
      api.rerender('1862a979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Hz6xJGIGPXlI/JS/comp/Accordion.vue"
export default component.exports